import { Link } from "react-router";
import { LegalPage } from "@/components/auth/LegalPage";
import { BRAND } from "@/lib/brand";

const EFFECTIVE = "2026년 11월 1일(예정)";

/**
 * 이용약관 , 초안(법무 검토 전).
 * 로그인 없이 볼 수 있고, 로그인돼 있으면 상단 막대가 산정 시작으로 돌아가는 길을 낸다.
 */
export function TermsPage() {
  return (
    <LegalPage title="이용약관" effective={EFFECTIVE}>
      <h2>제1조 (목적)</h2>
      <p>
        이 약관은 {BRAND.ORG}(이하 "연합")이 제공하고 주식회사 {BRAND.DEVELOPER}(이하 "운영사")가 운영하는 「{BRAND.TITLE} 프로그램」(이하 "서비스")의 이용과 관련하여, 서비스와 이용자의 권리, 의무와 책임사항을 정하는 것을 목적으로 합니다.
      </p>

      <h2>제2조 (정의)</h2>
      <ul>
        <li><b>서비스</b>: 웹 브라우저로 접속하여 수소의 생산, 저장, 이송 경로에서 나오는 온실가스 배출량을 교육 목적으로 모의산정하는 프로그램과 그 부속 자료(배출계수, 설비 템플릿, 교육용 예시, 용어 도움말, 보고서 출력 기능).</li>
        <li><b>이용자</b>: 이 약관에 동의하고 계정을 만들어 서비스를 이용하는 사람.</li>
        <li><b>계정</b>: 이메일과 비밀번호로 식별되는 이용자의 접속 단위.</li>
        <li><b>시나리오</b>: 이용자가 서비스에 입력하고 저장한 설비 구성과 운전자료, 그리고 그로부터 계산된 결과.</li>
        <li><b>마스터 데이터</b>: 서비스가 계산에 쓰는 배출계수, 전력원, 대상기술, 설비 템플릿, 산정방식 규칙, 교육용 예시, 용어 정의.</li>
      </ul>

      <h2>제3조 (약관의 효력과 변경)</h2>
      <ol>
        <li>이 약관은 서비스 화면에 게시하거나 가입 과정에서 표시함으로써 효력이 생깁니다.</li>
        <li>연합과 운영사는 관련 법령을 위반하지 않는 범위에서 약관을 바꿀 수 있으며, 바뀐 약관은 시행일 7일 전(이용자에게 불리한 변경은 30일 전)부터 서비스 화면에 공지합니다.</li>
        <li>이용자가 공지 후 시행일까지 거부 의사를 밝히지 않고 서비스를 계속 이용하면 변경된 약관에 동의한 것으로 봅니다.</li>
      </ol>

      <h2>제4조 (서비스의 내용)</h2>
      <ol>
        <li>
          서비스는 다음을 제공합니다.
          <ul>
            <li>KS I ISO 14040 및 14044 절차를 따른 교육용 온실가스 모의산정(산정 목적과 기본 조건, 산정 방식과 적용 기준, 기능단위와 기준흐름, 설비 구성, 시스템 경계, 운전자료 입력, 계산과정 확인, 결과 확인)</li>
            <li>일반 LCA 기반 산정과 국내 청정수소 인증제 모의산정, 두 가지 적용규칙</li>
            <li>교육용 예시, 배출계수와 용어 도움말, 결과 그래프, 보고서 인쇄, 시나리오 파일 저장 및 불러오기, CSV 내보내기</li>
          </ul>
        </li>
        <li>서비스는 무상으로 제공되며, 교육 운영 일정에 따라 이용 기간이 제한될 수 있습니다.</li>
        <li>마스터 데이터의 값(배출계수 등)은 전문가 검토와 발주기관 확인을 거쳐 갱신되며, 서비스는 화면에 자료 상태(임시값, 전문가 검토 완료, 발주기관 확인 완료)를 표시합니다.</li>
      </ol>

      <h2>제5조 (계정)</h2>
      <ol>
        <li>이용자는 유효한 이메일 주소로 가입할 수 있으며, 가입 시 입력하는 정보는 사실이어야 합니다. 교육용 계정은 일반 이메일로 이용할 수 있습니다.</li>
        <li>기업용 기능으로 전환하려면 본인이 접근할 수 있는 회사 이메일로 인증번호를 확인해야 합니다. 회사 이메일 인증은 접근 권한을 확인하는 절차이며, 회사와의 계약 또는 도입 승인을 대신하지 않습니다.</li>
        <li>계정과 비밀번호의 관리 책임은 이용자에게 있으며, 계정을 제3자에게 빌려주거나 공유할 수 없습니다.</li>
        <li>계정 도용이나 부정 사용을 알게 되면 이용자는 즉시 운영사에 알려야 합니다.</li>
        <li>이용자는 내 계정 화면에서 정보를 고칠 수 있고, 운영사에 요청하여 계정을 삭제(탈퇴)할 수 있습니다.</li>
      </ol>

      <h2>제6조 (이용자의 의무)</h2>
      <p>이용자는 다음 행위를 해서는 안 됩니다.</p>
      <ul>
        <li>타인의 정보로 가입하거나 계정을 양도 및 공유하는 행위</li>
        <li>서비스의 산출물(결과와 보고서)을 공식 검증 또는 인증 결과인 것처럼 표시하거나 제출하는 행위</li>
        <li>서비스의 소스코드와 마스터 데이터를 무단으로 복제, 배포 또는 역설계하는 행위</li>
        <li>서버에 과도한 부하를 주거나 다른 이용자의 이용을 방해하는 행위</li>
        <li>법령이나 이 약관에 어긋나는 행위</li>
      </ul>

      <h2>제7조 (산정 결과의 성격)</h2>
      <ol>
        <li>서비스의 계산 결과는 검증을 거치지 않은 <b>모의산정 결과</b>입니다. 기후변화 영향범주(온실가스)만 다루며, 산성화, 부영양화 등 다른 환경영향은 산정하지 않습니다.</li>
        <li>산정 결과는 종합적인 환경영향평가, 제3자 검증, 청정수소 인증기관의 공식 판정을 <b>대체하지 않으며</b>, 그러한 목적으로 제출,인용할 수 없습니다.</li>
        <li>배출계수와 기본값에는 전문가 검토 전의 임시값이 포함될 수 있으며, 서비스는 이를 화면과 보고서에 표시합니다. 이용자는 실제 의사결정에 결과를 쓰기 전에 원자료와 적용 기준을 스스로 확인해야 합니다.</li>
      </ol>

      <h2>제8조 (지식재산권)</h2>
      <ol>
        <li>서비스를 구성하는 프로그램, 화면, 마스터 데이터, 교육용 예시, 문서 등 프로그램 산출물에 대한 권리는 <b>{BRAND.ORG}</b>에 귀속됩니다.</li>
        <li>이용자가 입력한 시나리오와 운전자료에 대한 권리는 이용자에게 있으며, 연합과 운영사는 서비스 제공 및 개선과 교육 운영 통계 목적의 범위에서만 이를 처리합니다.</li>
        <li>이용자는 교육 및 학습 목적으로 결과와 보고서를 출력하고 보관할 수 있으나, 서비스 자체를 복제, 배포하거나 상업적으로 이용할 수 없습니다.</li>
      </ol>

      <h2>제9조 (서비스의 변경 및 중단)</h2>
      <ol>
        <li>연합과 운영사는 교육 과정 개편, 마스터 데이터 갱신, 시스템 점검 등의 사유로 서비스의 내용을 바꾸거나 일시 중단할 수 있으며, 예정된 중단은 미리 공지합니다.</li>
        <li>천재지변, 통신 장애, 클라우드 사업자의 장애 등 불가항력으로 서비스를 제공할 수 없는 경우 사전 공지 없이 중단될 수 있습니다.</li>
        <li>교육 프로그램이 종료되면 서비스와 저장된 시나리오는 <Link to="/privacy">개인정보처리방침</Link>이 정한 보유기간이 지난 뒤 삭제될 수 있습니다.</li>
      </ol>

      <h2>제10조 (면책)</h2>
      <ol>
        <li>연합과 운영사는 이용자가 서비스의 산정 결과를 근거로 내린 의사결정이나 제3자에게 제출한 자료로 인하여 생긴 손해에 대하여 책임지지 않습니다.</li>
        <li>이용자가 입력한 자료의 오류, 계정 관리 소홀, 이 약관 위반으로 생긴 손해는 이용자가 책임집니다.</li>
        <li>무상으로 제공되는 서비스에 대하여 연합과 운영사는 법령이 허용하는 범위에서, 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.</li>
      </ol>

      <h2>제11조 (준거법과 관할)</h2>
      <p>이 약관은 대한민국 법률에 따라 해석하며, 서비스 이용과 관련한 분쟁은 민사소송법이 정하는 관할법원에 제기합니다.</p>

      <h2>부칙</h2>
      <p>이 약관은 {EFFECTIVE}부터 시행합니다. 시행일과 조문은 법무 검토 후 확정합니다.</p>
    </LegalPage>
  );
}
